import { Link } from "react-router";
import iconThriveWave from "@assets/thrive_images/icon-thrive-wave.png";
import IconFactory from "@components/Icon/IconFactory";
import { IconTypeEnum } from "@components/Icon/utils/types";
import { THRIVE_INSTAGRAM_URL, THRIVE_TIKTOK_URL } from "@util/constant";

/**
 * Component to render thrive social media banner on thrive page
 * https://www.figma.com/design/UWKZEzXYf0Gf5e6sfqsKVC/THRIVE-WORKING-FILE?node-id=8869-84185&m=dev
 */
const ThriveSocialMediaBanner = (): React.ReactElement => {
  return (
    <div
      className="rounded-lg px-0 py-4 md:p-4 lg:mb-8 lg:border lg:border-[3px] lg:border-green-100 lg:bg-red-50"
      data-testid="thrive-social-media-banner"
    >
      <div className="mb-2 flex items-center justify-center gap-1">
        <p className="mb-0 font-fraunces text-4xl font-bold text-green-600">
          Come Say Hi!
        </p>

        <img width={33} height={40} alt="thrive-wave" src={iconThriveWave} />
      </div>

      <div className="flex flex-wrap justify-center gap-4 md:flex-nowrap">
        <Link
          target="_blank"
          to={THRIVE_INSTAGRAM_URL}
          className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-green-150 px-4 py-4 font-inter text-xs font-semibold text-gray-850 md:px-8 lg:w-1/2 lg:px-4"
        >
          <IconFactory type={IconTypeEnum.instagram} x={24} y={24} size={32} />
          we&apos;re here
        </Link>

        <Link
          to={THRIVE_TIKTOK_URL}
          target="_blank"
          className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-blue-155 px-4 py-4 font-inter text-xs font-semibold text-gray-850 md:px-8 lg:w-1/2 lg:px-4"
        >
          <IconFactory type={IconTypeEnum.tikTok} x={24} y={24} size={32} />
          and here
        </Link>
      </div>
    </div>
  );
};

export default ThriveSocialMediaBanner;
